export default "__VITE_ASSET__E8m3vL35__"